<script>
  import { onMount } from "svelte"
  import { shuffle } from "./helpers"
  import Location from "./Location.svelte"

  const greetings = shuffle(["Hello", "Cześć", "Hallo", "Bonjour", "Ahoj"])
  let greeting_index = 0
  let greeting_text = greetings[greetings.length - 1]
  let greeting_animating = false

  const changeText = (arr) => {
    if (arr[greeting_index]) {
      greeting_text = arr[greeting_index]
      greeting_index++
    } else {
      greeting_text = arr[0]
      greeting_index = 0
    }
  }

  onMount(async () => {
    setInterval(changeText, 5000, greetings)
    greeting_animating = true
  })
</script>

<div id="location-popup_wrapper">
  <div id="location-popup">
    <div class="location-popup_content">
      {#key greeting_index}
      <p class="location-popup_title" class:animating={greeting_animating}>
        {@html greeting_text}
      </p>
      {/key}
	  <Location />
      <div class="location-popup_help">
        <div>
          Need help? Contact us at
          <a href="info@slf24.com">info@slf24.com</a>
        </div>
      </div>
    </div>
    <div class="location-popup_image" />
  </div>
  <div class="logo">
    <img src="img/logo-white.svg" alt="SLF24 Logo" />
  </div>
</div>

<style lang="sass">
	@import './App.sass'
</style>
